export const applications: string[] = [
  "Merchant Portal",
  "Workday",
  "UPOP",
  "Cybersource",
  "GSAP",
  "MIGS",
  "Local Administrator Exception",
  "Removable Media (USB / CD / DVD Drive) Access",
  "Salesforce (Sales and Customer Service Platform)",
  "Salesforce (Sales and Customer Service Platform) - AP Region",
  "Salesforce (Sales and Customer Service Platform) - Canada Region",
  "Salesforce (Sales and Customer Service Platform) - CSP Region",
  "Salesforce (Sales and Customer Service Platform) - Marketing",
  "Salesforce (Sales and Customer Service Platform) - Mexico Region",
  "Salesforce (Sales and Customer Service Platform) - MNC Region",
  "Salesforce (Sales and Customer Service Platform) - UK Region",
];
